<template>
  <div
  v-bind:class="{
    'menu-visible': isMenuOpen
  }"
  class="page">
    <div
    v-on:click="toggleMenu()" ontouchstart=""
    class="overlay"></div>

    <div class="left ">
      <navi
      v-on:onClickDealerRegistration="openDealerRegistrationModal()"
      v-on:onClickChangePassword="openChangePasswordModal()"
      v-on:onClickLogout="openLogoutModal()"
      v-on:onClickMenu="onClickMenu()"></navi>
    </div>

    <div class="right ">
      <transition name="fade" mode="out-in" appear>
        <router-view
        v-on:openChangePhotoModal="openChangePhotoModal()"
        v-on:openChangeNameModal="openChangeNameModal()"
        v-on:openChangeIPUserNameModal="openChangeIPUserNameModal()"
        v-on:openChangeEmailModal="openChangeEmailModal()"
        v-on:openChangeDealerInfoModal="openDealerRegistrationModal()"
        v-on:openChangePasswordModal="openChangePasswordModal()"></router-view>
      </transition>
    </div>

    <div
    v-on:click="toggleMenu()" ontouchstart=""
    class="menu-btn">
      <comp-icon
      v-bind:icon="'menu'"
      v-bind:width="25"></comp-icon>
    </div>

    <!-- modal -->
    <transition name="fade" mode="out-in" appear>
      <div
      v-if="modals.openEnduserApp.isVisible"
      class="modal-wrapper">
        <modal-open-enduser-app
        v-on:closeModalRequest="closeOpenEnduserAppModal()"></modal-open-enduser-app>
      </div>
    </transition>
    <!-- modal -->

    <!-- modal -->
    <transition name="fade" mode="out-in" appear>
      <div
      v-if="modals.openDealerPortal.isVisible"
      class="modal-wrapper">
        <modal-open-dealer-portal
        v-on:closeModalRequest="closeOpenDealerPortalModal()"></modal-open-dealer-portal>
      </div>
    </transition>
    <!-- modal -->

    <!-- modal -->
    <transition name="fade" mode="out-in" appear>
      <div
      v-if="modals.changePhoto.isVisible"
      class="modal-wrapper">
        <modal-change-photo
        v-on:closeModalRequest="closeChangePhotoModal()"></modal-change-photo>
      </div>
    </transition>
    <!-- modal -->

    <!-- modal -->
    <transition name="fade" mode="out-in" appear>
      <div
      v-if="modals.changeName.isVisible"
      class="modal-wrapper">
        <modal-change-name
        v-on:closeModalRequest="closeChangeNameModal()"></modal-change-name>
      </div>
    </transition>
    <!-- modal -->

    <!-- modal -->
    <transition name="fade" mode="out-in" appear>
      <div
      v-if="modals.changeIPUserName.isVisible"
      class="modal-wrapper">
        <modal-change-ip-user-name
        v-on:closeModalRequest="closeChangeIPUserNameModal()"></modal-change-ip-user-name>
      </div>
    </transition>
    <!-- modal -->

    <!-- modal -->
    <transition name="fade" mode="out-in" appear>
      <div
      v-if="modals.changeEmail.isVisible"
      class="modal-wrapper">
        <modal-change-email
        v-on:closeModalRequest="closeChangeEmailModal()"></modal-change-email>
      </div>
    </transition>
    <!-- modal -->

    <!-- modal -->
    <transition name="fade" mode="out-in" appear>
      <div
      v-if="modals.emailChanged.isVisible"
      class="modal-wrapper">
        <modal-email-changed
        v-on:closeModalRequest="closeEmailChangedModal()"></modal-email-changed>
      </div>
    </transition>
    <!-- modal -->

    <!-- modal -->
    <transition name="fade" mode="out-in" appear>
      <div
      v-if="modals.changePassword.isVisible"
      class="modal-wrapper">
        <modal-change-password
        v-on:closeModalRequest="closeChangePasswordModal()"></modal-change-password>
      </div>
    </transition>
    <!-- modal -->

    <!-- modal -->
    <transition name="fade" mode="out-in" appear>
      <div
      v-if="modals.dealerRegistration.isVisible"
      class="modal-wrapper">
        <modal-dealer-registration
        v-on:closeModalRequest="closeDealerRegistrationModal()"></modal-dealer-registration>
      </div>
    </transition>
    <!-- modal -->

    <!-- modal -->
    <transition name="fade" mode="out-in" appear>
      <div
      v-if="modals.logout.isVisible"
      class="modal-wrapper">
        <modal-logout
        v-on:closeModalRequest="closeLogoutModal()"></modal-logout>
      </div>
    </transition>
    <!-- modal -->

    <!-- notifications -->
    <notifications></notifications>
    <!-- notifications -->

  </div>
</template>

<script>
import CompIcon from '@/components/CompIcon'
import Navi from '@/pages/Account/Navi'
import Notifications from '@/pages/Account/Notifications'
import ModalChangeName from '@/components/Modal/ModalChangeName'
import ModalChangeIpUserName from '@/components/Modal/ModalChangeIpUserName'
import ModalChangePassword from '@/components/Modal/ModalChangePassword'
import ModalChangeEmail from '@/components/Modal/ModalChangeEmail'
import ModalEmailChanged from '@/components/Modal/ModalEmailChanged'
import ModalChangePhoto from '@/components/Modal/ModalChangePhoto'
import ModalDealerRegistration from '@/components/Modal/ModalDealerRegistration'
import ModalOpenDealerPortal from '@/components/Modal/ModalOpenDealerPortal'
import ModalOpenEnduserApp from '@/components/Modal/ModalOpenEnduserApp'
import ModalLogout from '@/components/Modal/ModalLogout'
export default {
  name: 'account',
  components: {
    CompIcon,
    Navi,
    Notifications,
    ModalChangeName,
    ModalChangeIpUserName,
    ModalChangePassword,
    ModalChangeEmail,
    ModalEmailChanged,
    ModalChangePhoto,
    ModalDealerRegistration,
    ModalOpenDealerPortal,
    ModalOpenEnduserApp,
    ModalLogout
  },
  computed: {
    isAuthenticated: function () {
      return this.$store.getters.isAuthenticated
    },
    statusCheckSession: function () {
      return this.$store.getters.statusCheckSession
    },
    myDealerHasPendingRegistration: function () {
      return this.$store.getters.myDealerHasPendingRegistration
    },
    iAmOwnerOfMyDealer: function () {
      return this.$store.getters.iAmOwnerOfMyDealer
    },
    isToResetPassword: function () {
      return this.$store.getters.isToResetPasswordAuth0 && (this.$store.getters.accountCreatedDate > this.$store.getters.newAccountLogicBeginDate)
    },
    myEmail: function () {
      return this.$store.getters.myEmail
    }
  },
  data: function () {
    return {
      isMenuOpen: true,
      modals: {
        changeName: {
          isVisible: false
        },
        changeIPUserName: {
          isVisible: false
        },
        changePassword: {
          isVisible: false
        },
        changeEmail: {
          isVisible: false
        },
        emailChanged: {
          isVisible: false
        },
        changePhoto: {
          isVisible: false
        },
        dealerRegistration: {
          isVisible: false
        },
        logout: {
          isVisible: false
        },
        openDealerPortal: {
          isVisible: false
        },
        openEnduserApp: {
          isVisible: false
        }
      },
      request: {}
    }
  },
  watch: {
    myDealerHasPendingRegistration: function () {
      this.openAppropriateModals()
    },
    iAmOwnerOfMyDealer: function () {
      this.openAppropriateModals()
    },
    isToResetPassword: function () {
      this.openAppropriateModals()
    },
    myEmail: function () {
      this.openAppropriateModals()
    },
    statusCheckSession: function (status) {
      if (status === 'successful') {
        this.checkAuthStatus()
      } else if (status === 'failed') {
        // do nothing here
        // it is handled in MyAuth.vue (redirecting to login page auth.chekt.com)
      }
    }
  },
  created: function () {
    this.initRequest()
    this.initResizeListener()
    this.checkAuthStatus()
    this.openAppropriateModals()
  },
  beforeDestroy: function () {
    this.removeResizeListener()
  },
  methods: {
    initResizeListener: function () {
      this.onResize()
      window.addEventListener('resize', this.onResize)
    },
    removeResizeListener: function () {
      window.removeEventListener('resize', this.onResize)
    },
    openAppropriateModals: function () {
      this.openEmailChangedModal()
      if (this.myDealerHasPendingRegistration && this.iAmOwnerOfMyDealer) {
        this.openDealerRegistrationModal()
      }
      if (this.isToResetPassword) {
        this.openChangePasswordModal()
      }
      if (this.myEmail) {
        if ('email' in this.request) {
          if (this.myEmail !== this.request['email']) {
            this.closeAllModal()
            this.openLogoutModal()
          } else {
            this.closeLogoutModal()
            if ('request' in this.request) {
              if (this.request['request'] === 'dealer_registration') {
                this.openOpenDealerPortalModal()
              } else if (this.request['request'] === 'dealer_member_invitation') {
                this.openOpenDealerPortalModal()
              } else if (this.request['request'] === 'site_member_invitation') {
                this.openOpenEnduserAppModal()
              }
            }
          }
        }
        // only when account email is changed
        if ('oldEmail' in this.request) {
          if (this.request['oldEmail']) {
            if (this.request['request'] === 'email_change') {
              this.openEmailChangedModal()
            } else if (this.request['request'] === 'email_change_revoke') {
              this.openEmailChangedModal()
            }
          }
        }
      }
    },
    onResize: function () {
      if (window.innerWidth > 600) {
        this.openMenu()
      } else {
        this.closeMenu()
      }
    },
    checkAuthStatus: function () {
      if (this.isAuthenticated()) {
        this.onAuthenticatedUser()
      } else {
        this.onNotAuthenticatedUser()
      }
    },
    onAuthenticatedUser: function () {
      this.getMyProfile().then(success => {
        this.getMyDealer().then(success => {}, failure => {
          this.$logger.debug('No my dealer')
        })
        this.getMySites().then(success => {}, failure => {
          this.$logger.debug('No my sites')
        })
      })
    },
    onNotAuthenticatedUser: function () {
      this.$router.push({name: 'Login', query: this.$route.query})
    },
    toggleMenu: function () {
      this.isMenuOpen = !this.isMenuOpen
    },
    openMenu: function () {
      this.isMenuOpen = true
    },
    closeMenu: function () {
      this.isMenuOpen = false
    },
    onClickMenu: function () {
      this.onResize()
      this.closeAllModal()
    },
    closeAllModal: function () {
      Object.keys(this.modals).map(modalName => {
        this.modals[modalName].isVisible = false
      })
    },
    openChangePhotoModal: function () {
      this.modals.changePhoto.isVisible = true
    },
    closeChangePhotoModal: function () {
      this.modals.changePhoto.isVisible = false
    },
    openChangeNameModal: function () {
      this.modals.changeName.isVisible = true
    },
    closeChangeNameModal: function () {
      this.modals.changeName.isVisible = false
    },
    openChangeIPUserNameModal: function () {
      this.modals.changeIPUserName.isVisible = true
    },
    closeChangeIPUserNameModal: function () {
      this.modals.changeIPUserName.isVisible = false
    },
    openChangePasswordModal: function () {
      this.modals.changePassword.isVisible = true
    },
    closeChangePasswordModal: function () {
      this.modals.changePassword.isVisible = false
    },
    openChangeEmailModal: function () {
      this.modals.changeEmail.isVisible = true
    },
    closeChangeEmailModal: function () {
      this.modals.changeEmail.isVisible = false
    },
    openEmailChangedModal: function () {
      this.modals.emailChanged.isVisible = true
    },
    closeEmailChangedModal: function () {
      this.modals.emailChanged.isVisible = false
    },
    openLogoutModal: function () {
      this.modals.logout.isVisible = true
    },
    closeLogoutModal: function () {
      this.modals.logout.isVisible = false
    },
    openDealerRegistrationModal: function () {
      this.modals.dealerRegistration.isVisible = true
    },
    closeDealerRegistrationModal: function () {
      this.modals.dealerRegistration.isVisible = false
    },
    openOpenDealerPortalModal: function () {
      this.modals.openDealerPortal.isVisible = true
    },
    closeOpenDealerPortalModal: function () {
      this.modals.openDealerPortal.isVisible = false
    },
    openOpenEnduserAppModal: function () {
      this.modals.openEnduserApp.isVisible = true
    },
    closeOpenEnduserAppModal: function () {
      this.modals.openEnduserApp.isVisible = false
    },
    getMyProfile: function () {
      return this.$store.dispatch('getMyProfile')
    },
    getMyDealer: function () {
      return this.$store.dispatch('getMyDealer')
    },
    getMySites: function () {
      return this.$store.dispatch('getMySites')
    },
    initRequest: function () {
      this.request = this.$param.options
    }
  }
}
</script>

<style scoped>
.page {
  /* common */
  background-color: #fefefe;
  /* text */
  word-break: break-word;
  /* size */
  width: 100%;
  height: 100%;
  padding: 0;
  /* position */
  position: absolute;
  top: 0;
  left: 0;
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  /* animation */
  transition: transform .3s;
}

.page .overlay {
  /* common */
  background-color: hsla(0, 0%, 0%, 0);
  /* size */
  width: 100%;
  height: 100%;
  padding: 0;
  /* position */
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.page .left {
  /* common */
  background-color: #F1F1F1;
  /* size */
  width: 200px;
  height: 100%;
  /* position */
  position: absolute;
  top: 0;
  left: -200px;
  z-index: 100;
  /* animation */
  transition: transform .3s;
}

.page .right {
  /* common */
  background-color: transparent;
  color: var(--gray-high);
  /* size */
  width: calc(100% - 44px * 2);
  height: calc(100% - 49px);
  padding: 0 44px;
  padding-top: 49px;
  /* position */
  position: absolute;
  top: 0;
  left: 0;
}

.page .menu-btn {
  /* common */
  color: var(--gray-high);
  /* size */
  width: 30px;
  height: 30px;
  /* position */
  position: absolute;
  top: 5px;
  left: 5px;
  /* alignment */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  /* mouse */
  cursor: pointer;
}
.page .menu-btn:hover {
  /* common */
  transition: 0.3s ease all;
  color: var(--gray-medium);
}

.page .modal-wrapper {
  /* common */
  z-index: 100;
}


.page.menu-visible {
  /* size */
  width: calc(100% - 200px);
  /* position */
  transform: translateX(200px);
}
.page.menu-visible .left {
  /* size */
  padding: 0;
}
.page.menu-visible .right {
  /* size */
  width: calc(100% - 44px * 2);
}

@media only screen and (max-width: 600px) {
  .page .right {
    /* size */
    width: calc(100% - 11px * 2);
    padding: 0 11px;
    padding-top: 49px;
  }

  .page.menu-visible {
    /* size */
    width: 100%;
    /* position */
    transform: translateX(0);
  }
  .page.menu-visible .overlay {
    /* common */
    background-color: hsla(0, 0%, 0%, 0.9);
    /* position */
    z-index: 10;
  }
  .page.menu-visible .left {
    /* position */
    transform: translateX(100%);
  }
  .page.menu-visible .right {
    /* size */
    width: calc(100% - 11px * 2);
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/Account.vue